<template>
  <div>
    <b-card>
      <b-row>
        <div class="border-bottom pb-2 label-header mb-3 px-3">
          <label>Wallet Information</label>
        </div>
        <div class="col-lg-12 px-3 py-2">
          <div class="d-flex border-bottom pb-2 mb-3">
            <b-card class="col-lg-5">
              <div class="d-flex mb-3">
                <i class="bx bx-globe me-2" style="margin-top: 12px"></i>
                <div class="d-flex flex-column">
                  <p class="mb-1 fs-13px">Wallet Address</p>
                  <label class="mb-1" v-if="peddlrWalletDetails.acct_no">{{ peddlrWalletDetails.acct_no }}</label>
                  <label class="text-danger" v-else>No existing Peddlr Wallet</label>
                </div>
              </div>

              <div class="d-flex align-items-center mb-3">
                <i class="mdi mdi-wallet me-2"></i>
                <div class="d-flex flex-column">
                  <p class="mb-1 fs-13px">Peddlr Wallet</p>
                  <label class="mb-1" :class="{ 'text-muted': !peddlrWalletDetails.cognito_sub }">₱{{ peddlrWalletDetails.availableBalance ? peddlrWalletDetails.availableBalance.toLocaleString(undefined, {minimumFractionDigits: 2}) : '0.00'  }}</label>
                  <b-progress 
                    :value="peddlrWalletDetails.monthly_outgoing != null ? peddlrWalletDetails.monthly_outgoing : '0'" 
                    :max="peddlrWalletDetails.limit_amount != null ? peddlrWalletDetails.limit_amount : '0'" 
                    height="4px"
                  ></b-progress>
                  <p style="font-size: small">
                    <span class="text-dark">₱{{ peddlrWalletDetails.monthly_outgoing != null ? peddlrWalletDetails.monthly_outgoing.toLocaleString(undefined, {minimumFractionDigits: 2}) : '0.00' }} </span
                    ><span class="text-muted">Used</span> -
                    <span class="text-dark">₱{{ peddlrWalletDetails.limit_amount != null ? peddlrWalletDetails.limit_amount.toLocaleString(undefined, {minimumFractionDigits: 2}) : '0.00' }} </span
                    ><span class="text-muted">Limit</span>
                  </p>
                </div>
              </div>

              <div class="d-flex mb-3">
                <i class="bx bx-user-circle me-2" style="margin-top: 12px"></i>
                <div class="d-flex flex-column">
                  <p class="mb-1 fs-13px">Store Owner</p>
                  <label class="mb-1">{{ businessDetails.subscriberName }}</label>
                </div>
              </div>
              <div class="d-flex mb-3">
                <i class="bx bx-store-alt me-2" style="margin-top: 12px"></i>
                <div class="d-flex flex-column">
                  <p class="mb-1 fs-13px">Business Name</p>
                  <label class="mb-1">{{ businessDetails.businessName }}</label>
                </div>
              </div>
            </b-card>
            <div class="col-lg-7 ps-4 py-3">
              <div class="mb-3">
                <label class="label-header">Wallet Address</label>
                <b-form-input disabled v-model="peddlrWalletDetails.acct_no" style="font-weight: 500;"></b-form-input>
              </div>
              <div class="mb-3">
                <label class="label-header"
                  >Peddlr Wallet Monthly Transaction Limit (₱{{ peddlrWalletDetails.limit_amount != null ? peddlrWalletDetails.limit_amount.toLocaleString(undefined, {minimumFractionDigits: 2}) : '0.00' }} current limit)</label
                >
                <div class="input-group mb-2">
                  <span class="input-group-text" id="basic-addon1"
                    ><b>₱</b></span
                  >
                  <b-form-input
                    :class="{ 'border-danger': submitted && (this.currentLimit == null || this.currentLimit < minWalletLimit || this.currentLimit > maxWalletLimit)}"
                    type="number"
                    class="form-control"
                    placeholder="Enter Limit"
                    v-model="currentLimit"
                    @change="submitted = false;"
                    :disabled="!peddlrWalletDetails.cognito_sub"
                  ></b-form-input>
                </div>
                <div v-if="submitted && (this.currentLimit == null || this.currentLimit < minWalletLimit || this.currentLimit > maxWalletLimit)" class="text-danger">
                  <span class="small">Limit should be {{ minWalletLimit.toLocaleString() }} to {{ maxWalletLimit.toLocaleString() }}</span>
                </div>
                <p class="text-muted" style="font-size: small">
                  Minimum of ₱{{ minWalletLimit.toLocaleString() }} - Maximum ₱{{ maxWalletLimit.toLocaleString() }}
                </p>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <label class="me-2 mb-0">Activity Log:</label>
            <b-link @click="showLimitLogsModal()" :class="{ 'text-muted': !peddlrWalletDetails.cognito_sub }" :disabled="!peddlrWalletDetails.cognito_sub">View</b-link>
            <button type="button" class="btn btn-primary ms-auto me-2" @click="updateLimit()" v-if="peddlrWalletDetails.cognito_sub">
              Update
            </button>
            <button type="button" class="btn btn-light" :class="{ 'ms-auto': !peddlrWalletDetails.cognito_sub }" @click="$router.back()">Cancel</button>
            <!-- <div class="d-flex">
            </div> -->
          </div>
        </div>
      </b-row>
    </b-card>

    <!-- Activity Log Modal -->
    <b-modal
      v-model="showActivityLogsModal"
      size="xl"
      hide-header
      hide-title
      hide-footer
      hide-header-close
      no-close-on-backdrop
    >
      <span class="float-end c-pointer" @click="showActivityLogsModal = false"
        ><i class="bx bx-x fs-3"></i
      ></span>
      <h5>Wallet Limit Activity Log</h5>
      <div class="d-flex flex-wrap mt-4 mb-2">
        <div class="me-2 ta-right">
          <b-form-group description="Filter by date">
            <flat-pickr
              v-model="searchValue.dateRange"
              :config="rangeOptions"
              placeholder="Select a date range"
              class="form-control"
              style="width: fit-content"
            ></flat-pickr>
          </b-form-group>
        </div>
        <div class="me-2">
          <a
            class="btn btn-primary h-fit"
            @click="
              isSearching = true;
              getActivityLogs();
            "
          >
            <i class="bx bx-search bx-fw"></i>Search
          </a>
        </div>
      </div>

      <div class="table-responsive mb-0">
        <div class="table align-middle table-nowrap">
          <b-table
            :items="peddlrWalletLimitLogs"
            :fields="fields"
            responsive="sm"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="table-check"
            @sort-changed="tableSort"
          >
            <template #cell(updated_at)="data">
              {{ data.item.updated_at | formatDate }}
            </template>

            <template #cell(wallet_limit)="data">
              ₱{{ data.item.wallet_limit }}
            </template>
          </b-table>
        </div>
      </div>
      <!-- end table responsive -->
      <div class="row g-0 text-center" v-if="peddlrWalletLimitLogsTotal == 0">
        <span>No data to display.</span>
      </div>
      <div class="p-2"></div>

      <div class="row">
        <div class="col">
          <div class="form-group row pull-left" v-if="peddlrWalletLimitLogsTotal">
            <label for="staticEmail" class="col-sm-6 col-form-label"
              >Display:</label
            >
            <div class="col-sm-6">
              <b-form-group label-for="display-record">
                <b-form-select
                  class="form-select shadow-none w-fit"
                  id="display-record"
                  v-model="searchValue.rows"
                  :options="pageOptions"
                  @change="getActivityLogs()"
                ></b-form-select>
              </b-form-group>
            </div>
          </div>
          <div class="dataTables_paginate paging_simple_numbers float-end" v-if="peddlrWalletLimitLogsTotal > perPage">
            <b-pagination
              class="pagination-rounded"
              v-model="searchValue.page"
              :total-rows="peddlrWalletLimitLogsTotal"
              @input="getActivityLogs()"
              :per-page="searchValue.rows"
            ></b-pagination>
          </div>
        </div>
      </div>

      <div class="ta-right">
        <a class="btn btn-light h-fit" @click="showActivityLogsModal = false">
          Close
        </a>
      </div>
    </b-modal>
  </div>
</template>

<script>
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import {
  customerMethods,
  customerListComputed,
  peddlrWalletMethods,
  peddlrWalletComputed,
  layoutMethods,
} from "@/state/helpers";
import Swal from 'sweetalert2';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  page: {
    title: "Peddlr Wallet Limit",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      businessId: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      sortBy: "id",
      sortDesc: true,
      searchValue: {
        dateRange: null,
        sort: 'id',
        orderDesc: true,
        page: 1,
        rows: 10,
      },
      rangeOptions: {
        mode: "range",
      },
      fields: [
        { key: "updated_by", label: "Modified By", sortable: true },
        { key: "updated_at", label: "Modified Date & Time", sortable: true },
        { key: "wallet_address", sortable: true },
        { key: "wallet_limit", label: "Peddlr Wallet Limit", sortable: true },
      ],
      activityLogs: [],
      showActivityLogsModal: false,
      isSearching: false,
      currentLimit: null,
      submitted: false,
      minWalletLimit: 10000,
      maxWalletLimit: 500000,
    };
  },
  validations: {
    currentLimit: { required }
  },
  components: {
    flatPickr,
  },
  computed: {
    ...customerListComputed,
    ...peddlrWalletComputed,
  },
  mounted() {
    this.businessId = this.$route.params.bid;
    this.changeTitle({ title: "Peddlr Wallet Limit" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Merchant List", to: { name: "Subscriber" } },
        { text: "Merchant Detail", to: { name: "Profile Information", params: { tab: 'Profile', bid: this.businessId} } },
        { text: "Peddlr Wallet Transactions", to: { name: "Profile Information Wallet", params: { tab: 'Profile', bid: this.businessId, wallet: 'peddlr-wallet'} } },
        { text: "Edit Wallet Limit", to: { name: "" } },
      ],
    });
    this.getBusinessDetails({ id: this.businessId });
    this.getPeddlrWalletDetails({ businessId: this.businessId });
  },
  methods: {
    ...layoutMethods,
    ...customerMethods,
    ...peddlrWalletMethods,
    async updateLimit() {
      this.submitted = true;
      this.$v.$touch();

      if (this.currentLimit == null || this.currentLimit < this.minWalletLimit || this.currentLimit > this.maxWalletLimit) {
        return;
      }

      let params = {
        businessId: this.businessId,
        limit: this.currentLimit,
        updatedBy: JSON.parse(localStorage.getItem("userData")).email,
      }

      this.updatePeddlrWalletLimit(params)
        .then(() => {
          Swal.fire(
            "Update Successful!",
            `${this.businessDetails.subscriberName}'s Wallet has been updated.`,
            "success"
          ).then(() => {
            this.$router.back();
          });
        }).catch((err) => {
            console.log('updatePeddlrWalletLimit error: ', err)
            Swal.fire("Update Failed!", 'Unexpected error occurred.', "error")
        });
    },
    async showLimitLogsModal() {
      this.getActivityLogs()
        .then(() => {
          this.showActivityLogsModal = true;
        })
    },
    async getActivityLogs() {
      this.searchValue.page = this.isSearching ? 1 : this.searchValue.page;

      let params = {
        walletAddress: this.peddlrWalletDetails.cognito_sub,
        dateRange: this.searchValue.dateRange,
        page: this.searchValue.page,
        rows: this.searchValue.rows,
        sort: this.searchValue.sort,
        orderDesc: this.searchValue.orderDesc,
      };

      this.getPeddlrWalletLimitLogs(params)
        .then(() => {
          this.isSearching = false;
        });
    },
    async tableSort(action) {
      this.isSearching = true;
      this.sortBy = action.sortBy;
      this.sortDesc = action.sortDesc;
      await this.getErentaTransactions();
    }
  },
};
</script>

<style>
.mdi-wallet,
.bx-globe,
.bx-user-circle,
.bx-store-alt {
  font-size: 25px;
  color: #7f4697;
}

.label-header {
  font-size: 16px;
}

.fs-13px {
  font-size: 13px;
}
</style>
